import { AfterViewInit, Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, ValidationErrors, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '../../../../shared/pipes/translate.pipe';
import { OverlayService } from '../../../../shared/services/overlayService';
import { UserService } from '../../../../shared/services/user.service';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { User } from '../../../../shared/interfaces';
import { SelectedInvitersChange } from '../../../../shared/components/review-link/review-link-settings/mtm-inviter-dropdown/mtm-inviter-dropdown.component';

@Component({
  selector: 'mtm-new-workspace-user-modal',
  templateUrl: './new-workspace-user.component.html',
  styleUrl: './new-workspace-user.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class NewWorkspaceUserComponent implements OnDestroy, AfterViewInit {
  @Input() companyUsers: User[] = [];
  @Input() currentUsers: User[] = [];
  nameChanged: boolean = false;
  companies: any[] = [];
  workspaces: any[] = [];
  invitedUsers: any;
  sending: boolean = false;
  private readonly ngUnsubscribe = new Subject<void>();
  userForm = this.fb.group({
    username: ['', [Validators.required, this.validateName()]],
  });

  constructor(
    private readonly fb: FormBuilder,
    private readonly modal: NgbActiveModal,
    private readonly translatePipe: TranslatePipe,
    private readonly overlayService: OverlayService,
    private readonly userService: UserService
  ) {}

  ngAfterViewInit(): void {
    const searchBox = document.querySelector('.mtm-inviter-dropdown-component .search-box');
    if (searchBox) searchBox.setAttribute('autocomplete', 'mtm');
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  validateName() {
    return (control: FormControl): ValidationErrors | null => {
      const username = control.value.trim();

      const existingUser = this.currentUsers.find((u) => u.username == username);
      if (existingUser) {
        return {
          duplicate: {
            message: 'workspace_userExists',
          },
        };
      }
      return null;
    };
  }

  cancel() {
    this.modal.dismiss();
  }

  nameChange(e: SelectedInvitersChange) {
    if (e.invalid || e.value.length == 0) return;

    this.userForm.patchValue({
      username: e.value[0],
    });
    this.nameChanged = true;
  }

  save() {
    if (!this.userForm.valid || this.sending) return;

    const usernameToAdd = this.userForm.value.username;

    if (this.companyUsers.some((u) => u.username == usernameToAdd)) {
      const user = this.companyUsers.find((u) => u.username == usernameToAdd);
      this.modal.close({ formData: this.userForm.value, userData: user });
    } else {
      this.sending = true;
      this.userService
        .findUserByUsername(usernameToAdd, false, false)
        .pipe(
          takeUntil(this.ngUnsubscribe),
          finalize(() => (this.sending = false))
        )
        .subscribe({
          next: (user) => {
            if (!user) {
              this.modal.close(this.userForm.value);
            } else {
              this.overlayService.showError(
                this.translatePipe.transform('workspace_cannotAddUserFromAnotherCompany'),
                'Error'
              );
            }
          },
          error: () => {
            this.modal.close(this.userForm.value);
          },
        });
    }
  }
}
